/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Moonbar, MoonbarInterface } from "../Moonbar";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "routerAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethReceived",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nextAvailableClaimDate",
        type: "uint256",
      },
    ],
    name: "ClaimBNBSuccessfully",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensSwapped",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethReceived",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokensIntoLiqudity",
        type: "uint256",
      },
    ],
    name: "SwapAndLiquify",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "enabled",
        type: "bool",
      },
    ],
    name: "SwapAndLiquifyEnabledUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "accIsExcludedFromFee",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "activateContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_ofAddress",
        type: "address",
      },
    ],
    name: "calculateBNBReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimBNBReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tAmount",
        type: "uint256",
      },
    ],
    name: "deliver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "disableEasyRewardFrom",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "disruptiveCoverageFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "disruptiveTransfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "disruptiveTransferEnabledFrom",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "easyRewardCycleBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "excludeFromFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "excludeFromReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getRewardCycleBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "includeInFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "includeInReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "isExcludedFromReward",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidityFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTxAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "nextAvailableClaimDate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pancakePair",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pancakeRouter",
    outputs: [
      {
        internalType: "contract IPancakeRouter02",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tAmount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_deductTransferFee",
        type: "bool",
      },
    ],
    name: "reflectionFromToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardCycleBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_value",
        type: "bool",
      },
    ],
    name: "setExcludeFromMaxTx",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_liquidityFee",
        type: "uint256",
      },
    ],
    name: "setLiquidityFeePercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxTxPercent",
        type: "uint256",
      },
    ],
    name: "setMaxTxPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_enabled",
        type: "bool",
      },
    ],
    name: "setSwapAndLiquifyEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_taxFee",
        type: "uint256",
      },
    ],
    name: "setTaxFeePercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "swapAndLiquifyEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "taxFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "threshHoldTopUpRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_rAmount",
        type: "uint256",
      },
    ],
    name: "tokenFromReflection",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalFees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "winningDoubleRewardPercentage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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$b4ae538d42a0e0bb8330684d08e51a40b4$__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__$b4ae538d42a0e0bb8330684d08e51a40b4$__63c549d3ae7f000000000000000000000000000000000000000000000000000000000000000061dead61117485600561184d565b6040518463ffffffff1660e01b8152600401611192939291906127b0565b60006040518083038186803b1580156111aa57600080fd5b505af41580156111be573d6000803e3d6000fd5b505050506111e06111d960058361184d90919063ffffffff16565b8290611911565b90505b6111eb611509565b6111f59042612d13565b3360008181526014602052604090819020839055517f76a3a606d310d32750e15a3d246d186b789084096189d51661559b0f97f3bec9926112399291859190612816565b60405180910390a16000336001600160a01b03168260405161125a906108f2565b60006040518083038185875af1925050503d8060008114611297576040519150601f19603f3d011682016040523d82523d6000602084013e61129c565b606091505b50509050806112bd5760405162461bcd60e51b815260040161085490612b95565b505060018055565b60135481565b6001600160a01b03811660009081526006602052604081205460ff161561130b57506001600160a01b038116600090815260036020526040902054610936565b6001600160a01b03821660009081526002602052604090205461090d90610ac3565b611335611859565b6001600160a01b03166113466113e0565b6001600160a01b03161461136c5760405162461bcd60e51b815260040161085490612b17565b600080546040516001600160a01b03909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3600080546001600160a01b0319169055565b600f5481565b6001600160a01b031660009081526006602052604090205460ff1690565b60125481565b6000546001600160a01b031690565b6113f7611859565b6001600160a01b03166114086113e0565b6001600160a01b03161461142e5760405162461bcd60e51b815260040161085490612b17565b601b55565b61143b611859565b6001600160a01b031661144c6113e0565b6001600160a01b0316146114725760405162461bcd60e51b815260040161085490612b17565b61147f4262093a80612d13565b60175562093a80600f55620151806010556005601855671bc16d674ec80000601355426016556114af600161168a565b6114b96001611602565b6114e6307f000000000000000000000000000000000000000000000000000000000000000060001961185d565b565b60185481565b60175481565b6060600d805461087190612d81565b601b5481565b6000601754421061151d5750600f546108f2565b5060105490565b60195481565b6000610909611537611859565b84610ab485604051806060016040528060258152602001612e166025913960046000611561611859565b6001600160a01b03908116825260208083019390935260409182016000908120918d168152925290205491906119fd565b600061090961159f611859565b8484600061191d565b60146020526000908152604090205481565b7f000000000000000000000000000000000000000000000000000000000000000081565b7f000000000000000000000000000000000000000000000000000000000000000081565b61160a611859565b6001600160a01b031661161b6113e0565b6001600160a01b0316146116415760405162461bcd60e51b815260040161085490612b17565b6015805460ff19168215151790556040517f53726dfcaf90650aa7eb35524f4d3220f07413c8d6cb404cc8c18bf5591bc1599061167f908390612837565b60405180910390a150565b611692611859565b6001600160a01b03166116a36113e0565b6001600160a01b0316146116c95760405162461bcd60e51b815260040161085490612b17565b6116ea6127106116e48360095461184190919063ffffffff16565b9061184d565b60125550565b6001600160a01b03918216600090815260046020908152604080832093909416825291909152205490565b611723611859565b6001600160a01b03166117346113e0565b6001600160a01b03161461175a5760405162461bcd60e51b815260040161085490612b17565b6001600160a01b03166000908152600560205260409020805460ff19169055565b611783611859565b6001600160a01b03166117946113e0565b6001600160a01b0316146117ba5760405162461bcd60e51b815260040161085490612b17565b6001600160a01b0381166117e05760405162461bcd60e51b81526004016108549061295a565b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b0319166001600160a01b0392909216919091179055565b60115481565b6000610a338284612d4b565b6000610a338284612d2b565b3390565b6001600160a01b0383166118835760405162461bcd60e51b815260040161085490612895565b6001600160a01b0382166118a95760405162461bcd60e51b815260040161085490612c89565b6001600160a01b0380841660008181526004602090815260408083209487168084529490915290819020849055517f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92590611904908590612ccb565b60405180910390a3505050565b6000610a338284612d6a565b6001600160a01b0384166119435760405162461bcd60e51b815260040161085490612bc5565b6001600160a01b0383166119695760405162461bcd60e51b8152600401610854906128d9565b600082116119895760405162461bcd60e51b815260040161085490612b4c565b61199584848484611aa7565b61199f8484611b2e565b6001600160a01b03841660009081526005602052604090205460019060ff16806119e157506001600160a01b03841660009081526005602052604090205460ff165b156119ea575060005b6119f685858584611dda565b5050505050565b60008184841115611a215760405162461bcd60e51b81526004016108549190612842565b505050900390565b6000806000611a36611f52565b9092509050611a45828261184d565b9250505090565b6000610a338284612d13565b6000806000806000806000806000611a6f8a61210f565b9250925092506000806000611a8d8d8686611a88611a29565b61214b565b919f909e50909c50959a5093985091965092945050505050565b6001600160a01b03841660009081526007602052604090205460ff16158015611ae957506001600160a01b03831660009081526007602052604090205460ff16155b15611b285760135481108015611b0157506016544210155b15611b2857601254821115611b285760405162461bcd60e51b815260040161085490612a7a565b50505050565b6000611b39306112cb565b90506012548110611b4957506012545b601e54600e549082101590610100900460ff16158015611b665750805b8015611ba457507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316846001600160a01b031614155b8015611bb2575060155460ff165b8015611c0457506001600160a01b03841630148015611c0257507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316836001600160a01b0316145b155b15611b2857601e5491506000611c1b83600261184d565b90506000611c2e60026116e48685611911565b90506000611c3c8583611911565b90506000611c4a8484611a4c565b6040516356feb11b60e01b8152909150479073__$b4ae538d42a0e0bb8330684d08e51a40b4$__906356feb11b90611ca8907f00000000000000000000000000000000000000000000000000000000000000009086906004016127fd565b60006040518083038186803b158015611cc057600080fd5b505af4158015611cd4573d6000803e3d6000fd5b505050506000611ced824761191190919063ffffffff16565b90506000611cfc82600361184d565b905073__$b4ae538d42a0e0bb8330684d08e51a40b4$__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__$b4ae538d42a0e0bb8330684d08e51a40b4$__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";

export class Moonbar__factory extends ContractFactory {
  constructor(linkLibraryAddresses: MoonbarLibraryAddresses, signer?: Signer) {
    super(_abi, Moonbar__factory.linkBytecode(linkLibraryAddresses), signer);
  }

  static linkBytecode(linkLibraryAddresses: MoonbarLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$b4ae538d42a0e0bb8330684d08e51a40b4\\$__", "g"),
      linkLibraryAddresses["__$b4ae538d42a0e0bb8330684d08e51a40b4$__"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    routerAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Moonbar> {
    return super.deploy(routerAddress, overrides || {}) as Promise<Moonbar>;
  }
  getDeployTransaction(
    routerAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(routerAddress, overrides || {});
  }
  attach(address: string): Moonbar {
    return super.attach(address) as Moonbar;
  }
  connect(signer: Signer): Moonbar__factory {
    return super.connect(signer) as Moonbar__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoonbarInterface {
    return new utils.Interface(_abi) as MoonbarInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Moonbar {
    return new Contract(address, _abi, signerOrProvider) as Moonbar;
  }
}

export interface MoonbarLibraryAddresses {
  ["__$b4ae538d42a0e0bb8330684d08e51a40b4$__"]: string;
}
